export const LOGIN_ROUTE = "/login";
export const TECHNICIAN_LOGIN_ROUTE = "/tekniker-login";

export function getLoginRouteByPreference(lastLoginPage: string | null, isTeknikerMode: boolean): string {
    if (isTeknikerMode) {
        return TECHNICIAN_LOGIN_ROUTE;
    }

    return lastLoginPage === "tekniker" ? TECHNICIAN_LOGIN_ROUTE : LOGIN_ROUTE;
}

export function isLoginRoutePath(path: string): boolean {
    const normalized = normalizePath(path);
    return normalized === trimSlash(LOGIN_ROUTE) || normalized === trimSlash(TECHNICIAN_LOGIN_ROUTE);
}

export function buildAbsoluteLoginUrlFromHref(href: string): string {
    const parts = href.split("/#/");
    const base = parts[0];
    return `${base}/#${LOGIN_ROUTE}`;
}

function normalizePath(path: string): string {
    return trimSlash((path || "").split("?")[0]);
}

function trimSlash(value: string): string {
    return (value || "").replace(/^\/+|\/+$/g, "");
}
